import { InputType } from '@/types';

import type { IInput } from '@/types';

/**
 * Whether an input carries no value at all — blank text, or a media slot with no
 * src. Deliberately weaker than `isFormValid`'s per-input check, which also
 * rejects a src that is present but not yet submittable (blob:/data:/uploading).
 *
 * Pairs with `input.optional` at the two places an empty optional input must not
 * behave like an unfilled required one: the Generate gate (`isFormValid`) and the
 * webhook payload (`buildParamsFromInputs`).
 */
const isInputEmpty = (input: IInput): boolean =>
  input.type === InputType.TEXT
    ? (input.value ?? '').trim().length === 0
    : !input.src;

export default isInputEmpty;
